import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import {
  Duration as OverlayDuration,
  Icon as OverlayIcon,
} from "scmp-app/components/video/video-duration-overlay/variants/homepage/styles";

/* Default layout is the compact row item — text on the left, a 144x96
   thumbnail on the right. The lead layout is applied by the consuming
   widget via styled overrides. */
export const StyledEntityLink = styled(EntityLink)`
  ${clickableFrameLinkStyles}
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const Container = styled.div`
  ${clickableFrameStyles(StyledEntityLink)}
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const Label = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.36px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
    letter-spacing: -0.32px;
  }
`;

export const CoverImage = styled.div`
  position: relative;

  flex: none;

  inline-size: 144px;

  ${Figure} {
    aspect-ratio: 3 / 2;
  }

  img {
    inline-size: 100%;
    block-size: 100%;

    object-fit: cover;
  }

  /* v2 restyling of the shared homepage duration overlay (Figma 6992:295537):
     Roboto Condensed time label, no play icon. Done via overrides so the
     v1-shared component itself stays untouched. */
  ${OverlayIcon} {
    display: none;
  }

  ${OverlayDuration} {
    color: #2c4692;
    font-family: ${fontRobotoCondensed};
    line-height: normal;
  }
`;
